import type { WsConnectionState } from '@/lib/socketManager';

export const stateConfig: Record<WsConnectionState, { color: string; label: string }> = {
  open: { color: 'bg-status-success', label: 'Connected' },
  connecting: { color: 'bg-status-warning animate-pulse', label: 'Connecting...' },
  closed: { color: 'bg-status-error', label: 'Disconnected' },
};

export const navStateConfig: Record<WsConnectionState, { label: string; dot: string }> = {
  open: { label: 'All systems normal.', dot: 'bg-status-info' },
  connecting: { label: 'Connecting...', dot: 'bg-status-warning animate-pulse' },
  closed: { label: 'Disconnected', dot: 'bg-status-error' },
};
